export class Library{
    sequencerType: string;
    readCharecteristics: string;
    readLength: number; 
    flowCell: string;  
    mode: string;  
    status: string;  
    ignoreFromRunPlanning: boolean;  
    jobId: string;  
    sampleName: string; 
    projectId: string;  
    projectName: string; 
    runId: string; 
    runMode: string; 
    plannedReads: number; 
    missingReads: number;
    tagInfo: TagInfo[];
    dueDate: string;
    dueDateRawData: string;
    highPriority: string; 
    constraintType: string; 
    constraintId: string; 
    libraryType: string; 
    sampleBarcode: string; 
    libraryBarcode: string;
    sampleShortcode: string;
    libraryShortcode: string;
    labName: string; 
    statusSetTime: string; 
    samplePosition? : string;
    plateID?: string
}

export class TagInfo{
    tagSequence: string;
    tagManufacturerindex: string;
    tagPlatePosStr: string;
}